import {ActionButton} from '@ark/web';
import PageContainer from '@landlord/layout/PageContainer';
import {Box, Stack, Typography} from '@mui/material';
import {InfoOutlined} from '@mui/icons-material';
import {useIntercom} from 'react-use-intercom';

type Props = {
  documentType: 'tenancy-agreement' | 'section-21' | 'both';
};

const COPY: Record<Props['documentType'], {title: string; body: string}> = {
  'tenancy-agreement': {
    title: 'Tenancy agreement generation is paused',
    body: 'Following the May 2026 policy changes that abolish Assured Shorthold Tenancies, we are pausing new tenancy agreement creation while we review our service. Existing agreements remain available to view and any in-flight signing can still be completed.',
  },
  'section-21': {
    title: 'Section 21 generation is paused',
    body: 'Following the May 2026 policy changes that abolish Section 21 no-fault evictions, we are pausing new Section 21 creation while we review our service. Existing notices remain available to view.',
  },
  both: {
    title: 'Document generation is paused',
    body: 'Following the May 2026 policy changes affecting tenancy agreements and Section 21 notices, we are pausing new document creation while we review our service. Existing documents remain available to view.',
  },
};

export const DocumentGenerationPaused = ({documentType}: Props) => {
  const intercom = useIntercom();
  const {title, body} = COPY[documentType];

  return (
    <PageContainer>
      <Stack
        alignItems="center"
        textAlign="center"
        spacing={3}
        sx={{mt: {xs: 4, md: 8}, mx: 'auto', maxWidth: 600}}
      >
        <Box
          sx={theme => ({
            width: 72,
            height: 72,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.grey[600],
          })}
        >
          <InfoOutlined sx={{fontSize: 36}} />
        </Box>
        <Typography variant="h1" fontSize="32px">
          {title}
        </Typography>
        <Typography color="text.secondary">{body}</Typography>
        <ActionButton
          variant="primary"
          onClick={() => {
            intercom.trackEvent('Document Generation Paused Contact', {
              documentType,
            });
            intercom.showNewMessage('');
          }}
        >
          Contact support
        </ActionButton>
      </Stack>
    </PageContainer>
  );
};
